if (!customElements.get('mix-match-picker')) {
  class MixMatchPicker extends HTMLElement {
    constructor() {
      super();

      this.cards = Array.from(this.querySelectorAll('[data-product-card]'));
      this.cards.forEach((card) => {
        card.quantity = 0;

        const decreaseBtn = card.querySelector('[data-mmp-decrease]');
        const increaseBtn = card.querySelector('[data-mmp-increase]');

        decreaseBtn.addEventListener('click', () => this.setQuantity(card, card.quantity - 1));
        increaseBtn.addEventListener('click', () => this.setQuantity(card, card.quantity + 1));
      });

      this.countEl = this.querySelector('[data-mmp-count]');
      this.submitBtn = this.querySelector('[data-mmp-submit]');
      this.tierEls = Array.from(this.querySelectorAll('[data-mmp-tier]'));

      if (this.submitBtn) {
        this.submitBtn.addEventListener('click', this.onSubmit.bind(this));
      }

      this.updateSummary();
    }

    setQuantity(card, quantity) {
      quantity = Math.max(0, quantity);
      card.quantity = quantity;
      card.classList.toggle('selected', quantity > 0);

      const qtyEl = card.querySelector('[data-mmp-qty]');
      if (qtyEl) qtyEl.textContent = quantity;

      this.syncUnits(card);
      this.updateSummary();
    }

    syncUnits(card) {
      const unitsContainer = card.querySelector('[data-mmp-units]');
      const template = card.querySelector('[data-mmp-unit-template]');

      if (!unitsContainer || !template) return;

      const units = Array.from(unitsContainer.children);

      // Multi-variant products: one selectable unit row per quantity.
      while (units.length < card.quantity) {
        const fragment = template.content.cloneNode(true);
        const unit = fragment.querySelector('.mmp__unit');
        unitsContainer.appendChild(fragment);
        const newUnit = unitsContainer.lastElementChild;
        newUnit.querySelectorAll('.mmp__unit-option').forEach((select) => {
          select.addEventListener('change', () => this.updateUnitVariant(card, newUnit));
        });
        this.updateUnitVariant(card, newUnit);
        units.push(newUnit);
      }

      while (units.length > card.quantity) {
        const unit = units.pop();
        unit.remove();
      }

      unitsContainer.hidden = card.quantity === 0;
    }

    updateUnitVariant(card, unit) {
      const dataEl = card.querySelector('[data-mmp-variants]');
      const variants = dataEl ? JSON.parse(dataEl.textContent) : [];
      const selects = Array.from(unit.querySelectorAll('.mmp__unit-option'));
      const selectedValues = selects.map((select) => select.value);

      const variant =
        variants.find((candidate) => {
          return selectedValues.every((value, index) => candidate[`option${index + 1}`] === value);
        }) || variants[0];

      if (!variant) return;

      const input = unit.querySelector('[data-mmp-variant-id]');
      if (input) input.value = variant.id;
    }

    updateSummary() {
      const count = this.cards.reduce((sum, card) => sum + card.quantity, 0);

      if (this.countEl) this.countEl.textContent = count;

      this.tierEls.forEach((tierEl) => {
        const qty = parseInt(tierEl.dataset.qty, 10);
        tierEl.classList.toggle('reached', count >= qty);
      });

      if (this.submitBtn) this.submitBtn.disabled = count === 0;
    }

    onSubmit(event) {
      event.preventDefault();

      const items = [];

      this.cards.forEach((card) => {
        if (card.quantity === 0) return;

        const unitsContainer = card.querySelector('[data-mmp-units]');
        const units = unitsContainer ? Array.from(unitsContainer.querySelectorAll('[data-mmp-variant-id]')) : [];

        if (units.length) {
          units.forEach((input) => {
            items.push({ id: parseInt(input.value, 10), quantity: 1 });
          });
        } else {
          items.push({ id: parseInt(card.dataset.defaultVariantId, 10), quantity: card.quantity });
        }
      });

      if (!items.length) return;

      this.submitBtn.classList.add('loading');
      this.submitBtn.disabled = true;

      const cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      const body = { items };
      if (cart) {
        body.sections = cart.getSectionsToRender().map((section) => section.id);
        body.sections_url = window.location.pathname;
      }

      fetch(`${window.routes.cart_add_url}`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
        },
        body: JSON.stringify(body),
      })
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            throw new Error(response.description || response.message);
          }

          if (cart) {
            cart.getSectionsToRender().forEach((section) => {
              const elementToReplace = document.getElementById(section.id);
              if (!elementToReplace || !response.sections || !response.sections[section.id]) return;
              const html = new DOMParser().parseFromString(response.sections[section.id], 'text/html');
              const minicartForm = html.querySelector('#minicart-form');
              if (minicartForm) elementToReplace.innerHTML = minicartForm.innerHTML;
            });
            if (typeof cart.cartAction === 'function') cart.cartAction();
            if (typeof cart.open === 'function') cart.open();
          }

          fetch('/cart.js')
            .then((res) => res.json())
            .then((updatedCart) => {
              document.querySelectorAll('.cart-count').forEach((el) => {
                if (el.classList.contains('cart-count-drawer')) {
                  el.innerHTML = `(${updatedCart.item_count})`;
                } else {
                  el.innerHTML = updatedCart.item_count > 100 ? '~' : updatedCart.item_count;
                }
              });
              if (document.querySelector('header-total-price')) {
                document.querySelector('header-total-price').updateTotal(updatedCart);
              }
            });
        })
        .catch((error) => console.error(error))
        .finally(() => {
          this.submitBtn.classList.remove('loading');
          const count = this.cards.reduce((sum, card) => sum + card.quantity, 0);
          this.submitBtn.disabled = count === 0;
        });
    }
  }

  customElements.define('mix-match-picker', MixMatchPicker);
}
